import { envConfig } from 'config';
import request from 'utils/request';

const API_BASE_URL = `${envConfig.API_BASE}/api`;

// v2 endpoints
export function getUserRequest(userId) {
  return fetch(`${API_BASE_URL}/v2/users/login`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': 'es-MX',
      Authorization: `Bearer ${userId}`,
    },
  }).then(async response => {
    if (!response.ok) {
      const error = new Error(response.statusText);
      error.response = response;
      error.status = response.status;
      throw error;
    }

    if (response.status === 204 || response.status === 205) {
      return null;
    }

    const contentType = response.headers.get('content-type');
    const isJson =
      contentType && (contentType.includes('application/json') || contentType.includes('application/hal+json'));

    return isJson ? response.json() : response.text();
  });
}

export function createUserRequest({ id, email }, options = {}) {
  return request(`${API_BASE_URL}/v2/users`, {
    method: 'POST',
    body: {
      id,
      email,
    },
    ...options,
  });
}

export function assignUserRolesToApplicationRequest(userId, applicationId, roles, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${applicationId}/roles`, {
    method: 'PUT',
    body: {
      roles,
    },
    ...options,
  });
}

export function getUserRolesByApplicationRequest(userId, applicationId, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${applicationId}/roles`, {
    method: 'GET',
    ...options,
  });
}

export function removeUserFromApplicationRequest(userId, applicationId, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${applicationId}`, {
    method: 'DELETE',
    ...options,
  });
}

export function deleteUserRequest(userId, appID, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${appID}`, {
    method: 'DELETE',
    ...options,
  });
}
